import { render, staticRenderFns } from "./editPanel.vue?vue&type=template&id=4b4641ba&"
import script from "./editPanel.vue?vue&type=script&lang=js&"
export * from "./editPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editPanel.vue"
export default component.exports